/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner } from './bulk-disable-monthly-usage-limit200-response-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableMonthlyUsageLimit200ResponseInnerReissue } from './bulk-disable-monthly-usage-limit200-response-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableMonthlyUsageLimit200ResponseInnerUser } from './bulk-disable-monthly-usage-limit200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup } from './bulk-disable-monthly-usage-limit200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInner
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkDisableMonthlyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimit200ResponseInnerUser}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'user': BulkDisableMonthlyUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkDisableMonthlyUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {BulkDisableMonthlyUsageLimit200ResponseInnerReissue}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInner
     */
    'reissue'?: BulkDisableMonthlyUsageLimit200ResponseInnerReissue | null;
}

export const BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkDisableMonthlyUsageLimit200ResponseInnerAvailableCurrenciesEnum];


